import { render } from "./tableLocation.vue?vue&type=template&id=c1beda2c&scoped=true&ts=true"
import script from "./tableLocation.vue?vue&type=script&lang=ts"
export * from "./tableLocation.vue?vue&type=script&lang=ts"

import "./tableLocation.vue?vue&type=style&index=0&id=c1beda2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1beda2c"]])

export default __exports__